'use client';
function assignRef(n, e) {
    'function' == typeof n ? n(e) : n && (n.current = e);
}
function assignRefs(...n) {
    return (e)=>{
        n.forEach((n)=>assignRef(n, e));
    };
}

export { assignRef, assignRefs };
